import { Avatar } from '@mui/material'
import './studentProfile.scss'
import Button from '../../components/button/Button'
import useScreenSize from '../../hooks/useScreenSize'
import Modal from '../../components/Modal/Modal'
import { useEffect, useState } from 'react'
import NewInput from '../../components/input/NewInput'
import { Formik } from 'formik'
import * as Yup from 'yup'
import BreadCrumbs from '../../components/breadcrumb/Breadcrumb'
import { ROUTES_PATH, UI_CONSTANT } from '../../utility/constants'
import { useNavigate, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { editStudentAcademicDetails, getStudentProfile } from '../../store/builders/student/student.builder'
import {
  capitalizeFirstLetter,
  convertDateFormat,
  handleInput,
  handleInputStringWithNum,
  handleName,
  handlePercentageInput,
} from '../../utility/genricFunction'
import { VALIDATION_MESSAGES } from '../../utility/constantValidationMessages'
import Loader from '../../components/loader/Loader'

function StudentProfile() {
  const navigate = useNavigate()
  const location = useLocation()
  const screenSize = useScreenSize()
  const dispatch = useDispatch()
  const [openEditModal, setOpenEditModal] = useState(false)

  const { user } = useSelector((store) => {
    return store.auth
  })

  const { studentInformation, studentAcademicDetails, loading } = useSelector((store) => {
    return store.student
  })

  // const [studentData] = studentInformation

  const studentIdData = user?.result?.studentId
  const photoUrl = user?.result?.userPhotoUrl

  const [initialValues, setInitialValues] = useState()

  useEffect(() => {
    if (studentIdData) dispatch(getStudentProfile(studentIdData))

    const filteredStudentData = studentAcademicDetails.filter((academic) => {
      return (
        academic.institution.length ||
        academic.stream.length ||
        academic.completionYear.length ||
        academic.percentage.length
      )
    })
    setInitialValues({ academicDetails: [...filteredStudentData] })
  }, [dispatch, studentIdData, openEditModal])

  const academicDetailsSchema = Yup.object().shape({
    academicDetails: Yup.array().of(
      Yup.object().shape({
        degree: Yup.string().required(VALIDATION_MESSAGES.DEGREE_REQUIRED),
        institution: Yup.string().required(VALIDATION_MESSAGES.SCHOOL_NAME_REQUIRED),
        stream: Yup.string().required(VALIDATION_MESSAGES.STREEM_REQUIRED),
        completionYear: Yup.string()
          .required(VALIDATION_MESSAGES.COMPLETION_YEAR_REQUIRED)
          .max(new Date().getFullYear(), VALIDATION_MESSAGES.COMPLETION_YEAR_VALID),
        // percentage:  Yup.number()
        // .min(0, 'Percentage cannot be less than 0')
        // .max(100, 'Percentage cannot be more than 100')
        // .optional(),
        percentage: Yup.string()
          .trim(VALIDATION_MESSAGES.PERCENTAGE_SPACE)
          .strict(true) // Ensures the trimming is enforced
          .matches(/^\d+(\.\d{1,2})?$/, VALIDATION_MESSAGES.PERCENTAGE_DECIMAL)
          .test('is-valid-number', VALIDATION_MESSAGES.PERCENTAGE, (value) => {
            const num = parseFloat(value)
            return num >= 0 && num <= 100
          })
          .optional(),
      }),
    ),
  })

  const handleCancelNow = () => {
    setOpenEditModal(false)
    updateURL(false, 'replace')
  }

  const breadCrumbsArr = [
    {
      title: UI_CONSTANT.MY_PROFILE,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.STUDENT_DASHBOARD,
    },
    {
      title: UI_CONSTANT.MY_PROFILE,
      link: ROUTES_PATH.STUDENT_PROFILE,
    },
  ]

  function capitalizeName(studentName) {
    // const firstName = studentName;
    const capitalizedFirstName = studentName?.charAt(0).toUpperCase()

    const capitalizedFullName = `${capitalizedFirstName}`

    return capitalizedFullName
  }

  // Update URL to include/remove modal query parameter
  const updateURL = (isOpen, action = 'push') => {
    const url = new URL(window.location)
    if (isOpen) {
      url.searchParams.set('editAcademicDetails', 'true')
    } else {
      url.searchParams.delete('editAcademicDetails')
    }
    navigate(`${url.pathname}${url.search}`, { replace: action === 'replace' })
  }

  useEffect(() => {
    // Check URL on mount to set initial modal state
    const params = new URLSearchParams(location.search)
    if (params.get('editAcademicDetails') === 'true') {
      setOpenEditModal(true)
    } else {
      setOpenEditModal(false)
    }
  }, [location.search])

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={academicDetailsSchema}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          setSubmitting(false)
        }, 400)
      }}
      enableReinitialize
    >
      {({ values, validateForm, setTouched }) => (
        <>
        {loading && <Loader loading={loading} />}
        {<Loader loading={loading} /> && <div className={`course-list ${screenSize}`}>
          <div className='filter-bar-wraper'>
            <div className='student-profile-subheader'>
              <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
            </div>
          </div>
          <div className='student-profile-wrapper'>
            <div className='student-avatar-wrapper'>
              <Avatar alt='Remy Sharp' src={photoUrl ? photoUrl : ''} className='student-profile-avatar'>
                {studentInformation && studentInformation[0]?.user?.userName ? capitalizeName(studentInformation && studentInformation[0]?.user?.userName) : '—'}
              </Avatar>
              <div className='student-details'>
                <h1 className='student-name'>{studentInformation && studentInformation[0]?.user?.userName || '—'}</h1>
                <p className='student-profile-subtitle'>Student </p>
                <div className='student-personal-detail'>
                  <div>
                    Email: <span>{studentInformation && studentInformation[0]?.user?.email || '—'}</span>
                  </div>
                  <div className='student-profile-hr' />
                  <div>
                    Mobile: <span>{studentInformation && studentInformation[0]?.user?.phone ? `+91-${studentInformation && studentInformation[0]?.user?.phone}` : '—'}</span>
                  </div>
                  <div className='student-profile-hr' />
                  <div>
                    DOB:{' '}
                    <span>{studentInformation && studentInformation[0]?.user?.birthDate ? convertDateFormat(studentInformation && studentInformation[0]?.user?.birthDate) : '—'}</span>
                  </div>
                </div>
              </div>
            </div>
            <Button
              customClassName='btn-edit-profile'
              onClick={() => {
                setOpenEditModal(true)
                updateURL(true)
              }}
            >
              {UI_CONSTANT.EDIT_PROFILE}
            </Button>
            {openEditModal && (
              <Modal
                open={openEditModal}
                title='Academic Details'
                setOpenModal={setOpenEditModal}
                handleClose={handleCancelNow}
                handleSaveNow={async () => {
                  const errors = await validateForm()

                  setTouched({
                    academicDetails: values.academicDetails.map(() => ({
                      degree: true,
                      institution: true,
                      stream: true,
                      completionYear: true,
                      percentage: true,
                    })),
                  })

                  const hasErrors = values.academicDetails.some(() => errors.academicDetails)
                  if (!hasErrors) {
                    updateURL(false, 'replace')
                    dispatch(editStudentAcademicDetails({ values, studentIdData, setOpenEditModal, dispatch }))
                  }
                }}
              >
                <div className='update-student-academic-details'>
                  {values?.academicDetails?.map((education, index) => {
                    return (
                      <div className='update-academic-student-div' key={index}>
                        <label
                          htmlFor=''
                          className={index === 0 ? 'academic-label-student-first' : 'academic-label-student'}
                        >
                          <p>{education?.degree}</p>
                        </label>
                        <NewInput
                          placeholder='Enter school name'
                          label={index === 0 && 'School name'}
                          name={`academicDetails[${index}].institution`}
                          width={'40%'}
                          onInput={handleInputStringWithNum}
                        />
                        <NewInput
                          placeholder='Enter stream'
                          label={index === 0 && 'Stream'}
                          name={`academicDetails[${index}].stream`}
                          width={'18%'}
                          onInput={handleName}
                        />
                        <NewInput
                          placeholder='Year'
                          label={index === 0 && 'Completion Year'}
                          name={`academicDetails[${index}].completionYear`}
                          width={'17%'}
                          maxLength={4}
                          fieldClassName='completion-year'
                          onInput={handleInput}
                        />
                        <NewInput
                          placeholder='00.00'
                          label={index === 0 && 'Percentage'}
                          name={`academicDetails[${index}].percentage`}
                          width={'16%'}
                          onInput={handlePercentageInput}
                          maxLength={5}
                        />
                      </div>
                    )
                  }) || 'No academic details found'}
                </div>
              </Modal>
            )}
          </div>
          <div className='student-profile-group-parent'>
            <div className='personal-info-title'>Personal Information</div>
            <div>
              <table className='personal-info-table' id='academic-details-student-profile'>
                <tr className='display-data-row-first'>
                  <td>Registration Date</td>
                  <td></td>
                  <td>Father Name</td>
                  <td>Mother Name</td>
                  <td>Parent Mobile No</td>
                </tr>
                <tr className='display-data-row-second'>
                  <td>{studentInformation && studentInformation[0]?.enrollmentDate ? convertDateFormat(studentInformation && studentInformation[0]?.enrollmentDate) : '—'}</td>
                  <td></td>
                  <td>{capitalizeFirstLetter(studentInformation && studentInformation[0]?.fatherName) || '—'}</td>
                  <td>{capitalizeFirstLetter(studentInformation && studentInformation[0]?.motherName) || '—'}</td>
                  <td>{studentInformation && studentInformation[0]?.parentPhone ? `+91 - ${studentInformation && studentInformation[0]?.parentPhone}` : '—'}</td>
                </tr>
              </table>
            </div>
          </div>

          <div className='student-profile-group-parent sub-div-student'>
            <div className='personal-info-title'>Academic Details</div>
            <div>
              <table className='personal-info-table' id='academic-details-student-profile'>
                <tr className='display-data-row-first'>
                  <td>Degree</td>
                  <td></td>
                  <td className='school-name'>School Name</td>
                  <td>Stream</td>
                  <td>Completion Year</td>
                  <td>Percentage</td>
                </tr>
                {studentInformation && studentInformation[0]?.academicDetails?.map((academicDetails, index) => {
                  return (
                    <>
                      <tr className='display-data-row-second' key={index}>
                        <td>{capitalizeFirstLetter(academicDetails?.degree) || '—'}</td>
                        <td></td>
                        <td>{capitalizeFirstLetter(academicDetails.institution) || '—'}</td>
                        <td>{capitalizeFirstLetter(academicDetails.stream) || '—'}</td>
                        <td className='completion-year'>{academicDetails.completionYear || '—'}</td>
                        <td>{academicDetails.percentage ? `${academicDetails.percentage}%` : '—'}</td>
                      </tr>
                      {studentInformation && studentInformation[0]?.academicDetails.length !== index + 1 && (
                        <tr>
                          <td className='spacing-div'></td>
                        </tr>
                      )}
                    </>
                  )
                }) || (
                  <>
                    <tr className='display-data-row-second'>
                      <td>—</td>
                      <td></td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td className='completion-year'></td>
                    </tr>
                  </>
                )}
              </table>
            </div>
          </div>

          <div className='student-profile-group-parent sub-div-student'>
            <div className='personal-info-title'>Work Experience</div>
            <div>
              <table className='personal-info-table' id='academic-details-student-profile'>
                <tr className='display-data-row-first'>
                  <td className='company-name'>Company Name</td>
                  <td></td>
                  <td>Designation</td>
                  <td>Profile</td>
                  <td>Experience</td>
                </tr>
                {studentInformation && studentInformation[0]?.workExperienceDetails?.map((workExperience, index) => {
                  return (
                    <>
                      <tr className='display-data-row-second' key={index}>
                        <td>{capitalizeFirstLetter(workExperience.companyName) || '—'}</td>
                        <td></td>
                        <td>{capitalizeFirstLetter(workExperience.designation) || '—'}</td>
                        <td>{capitalizeFirstLetter(workExperience.profile) || '—'}</td>
                        <td>{workExperience.years ? `${workExperience.years} years` : '—'} </td>
                      </tr>
                      {studentInformation && studentInformation[0]?.workExperienceDetails?.length !== index + 1 && (
                        <tr>
                          <td className='spacing-div'></td>
                        </tr>
                      )}
                    </>
                  )
                }) || (
                  <>
                    <tr className='display-data-row-second'>
                      <td>—</td>
                      <td></td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                    </tr>
                  </>
                )}
              </table>
            </div>
          </div>

          <div className='student-profile-group-parent sub-div-student course-detail-student'>
            <div className='personal-info-title'>Course Details</div>
            <div>
              <div>
                <p className='course-expectation-title'>Course Expectation:</p>
                <div className='course-expectation-desc'>
                  {capitalizeFirstLetter(studentInformation && studentInformation[0]?.courseDetails[0]?.courseExpectation) || '—'}
                </div>
              </div>
              <table className='personal-info-table course-details-row'>
                <tr className='display-data-row-first'>
                  <td className='border-none'>Branch</td>
                  <td>Batch</td>
                  <td>Student Code</td>
                </tr>
                <tr className='display-data-row-second '>
                  <td className='course-details-row border-none'>
                    {capitalizeFirstLetter(studentInformation && studentInformation[0]?.user?.branch?.branchName) || '—'}
                  </td>
                  <td>{studentInformation && studentInformation[0]?.courseDetails[0]?.batch.batchNo || '—'}</td>
                  <td>{studentInformation && studentInformation[0]?.studentCode || '—'}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>}
        </>
      )}
    </Formik>
  )
}

export default StudentProfile
